export enum PositionType {
    Cash = 1,
    Margin = 2,
    Short = 3,
}

export enum MutualFundUnit {
    Unit,
    Dollar,
}

export enum MutualFundCapitalGains {
    Reinvest = 'Reinvest',
    PayInCash = 'PayInCash',
}

export enum MutualFundDividends {
    Reinvest = 'Reinvest',
    PayInCash = 'PayInCash',
}

export enum SecurityType {
    Equity,
    Option,
    MutualFund,
    Bond,
    Etf,
    Algo,
}

export enum OrderType {
    Market = 'MARKET',
    Limit = 'LIMIT',
    Stop = 'STOP',
    StopLimit = 'STOP_LIMIT',
    Spread = 'Spread',
    Notional = 'Notional',
    Even = 'Even',
    Credit = 'Credit',
    Debit = 'Debit',
    TrailingStop = 'TRAILING_STOP',
    MarketOnClose = 'MARKET_ON_CLOSE',
    MarketOnOpen = 'MARKET_ON_OPEN',
    LimitOnClose = 'LIMIT_ON_CLOSE',
    LimitOnOpen = 'LIMIT_ON_OPEN',

    // TODO: Used in OV as OrderTypes, but they are algo types, should be handled differently in the future
    VWAP = 'VWAP',
    TWAP = 'TWAP',
    POV = 'POV',
}

export enum AlgoStrategy {
    VWAP = 'VWAP',
    TWAP = 'TWAP',
    POV = 'POV',
}

export enum TrailingStopType {
    Dollar = '$',
    Percent = '%',
}

export enum TradeDestination {
    SingleAccount,
    AveragePriceAccount,
    Model,
}

export enum OrderTransaction {
    Buy = 'BUY',
    BuyToOpen = 'BUY_TO_OPEN',
    BuyToClose = 'BUY_TO_CLOSE',
    BuyToCover = 'BUY_TO_COVER',
    Sell = 'SELL',
    SellToOpen = 'SELL_TO_OPEN',
    SellToClose = 'SELL_TO_CLOSE',
    ShortSell = 'SHORT_SELL',
    Open = 'OPEN',
    Close = 'CLOSE',
}

export enum OrderValidity {
    GoodForDay = 'DAY',
    GoodTilCanceled = 'GTC',
    GoodTilDate = 'GTD',
}

export enum OrderMarketTime {
    PreMarket = 'PRE_MARKET',
    CoreMarket = 'CORE_MARKET',
    PostMarket = 'POST_MARKET',
    AllMarket = 'ALL_MARKET',
    PreCoreMarket = 'PRE_CORE',
    PostCoreMarket = 'POST_CORE',
}

export enum OrderFillType {
    Any = 'ANY',
    AllOrNone = 'AON',
}

export enum OptionStrategy {
    // Unsupported strategies but could be available in future
    // CoveredCall = 'CoveredCall',
    // LongCallButterfly = 'LongCallButterfly',
    // ShortCalendarCall = 'ShortCalendarCall',
    // ShortCalendarPut = 'ShortCalendarPut',
    // DiagonalPutBearSpread = 'DiagonalPutBearSpread',
    // OptionRoll = 'OptionRoll',
    // Collar = 'Collar',

    // Current supported option strategies
    SingleLeg = 'SingleLeg',
    Spread = 'Spread',
    BuyWrite = 'BuyWrite',
    ShortStrangle = 'ShortStrangle',
    LongStrangle = 'LongStrangle',
    LongCallSpread = 'LongCallSpread',
    ShortCallSpread = 'ShortCallSpread',
    LongPutSpread = 'LongPutSpread',
    ShortPutSpread = 'ShortPutSpread',
    LongCalendarCallSpread = 'LongCalendarCallSpread',
    LongCalendarPutSpread = 'LongCalendarPutSpread',
    // Iron Condor is returned by back end as a strategy but short and long condors are not differentiated
    IronCondor = 'IronCondor',
    ShortIronCondor = 'ShortIronCondor',
    LongIronCondor = 'LongIronCondor',
    ShortIronButterfly = 'ShortIronButterfly',
    LongIronButterfly = 'LongIronButterfly',
    SyntheticLongStock = 'SyntheticLongStock',
    SyntheticShortStock = 'SyntheticShortStock',
}

export enum PriceType {
    Decimal = 'Decimal',
    Percentage = 'Percentage',
}
